/* eslint-disable id-length */
import React from 'react';
import PropTypes from 'prop-types';
import downArrowIcon from '../../../Assets/images/svg/dar_arrow.svg';

const MenuList = ({
  menuItems,
  activeMenuItem,
  activeSubmenuItem,
  activeSubmenuOption,
  expandedMenuItem,
  expandedSubmenuItem,
  isOpen,
  getMenuItemClass,
  toggleMasterSubmenu,
  toggleSubmenu,
  toggleSubmenuOptions,
}) => {
  const getNestedSubmenuItems = (submenuItem) => (
    submenuItem.submenuOptions?.length
      ? submenuItem.submenuOptions
      : (submenuItem.submenuItems || [])
  );

  const handleLinkClick = (e, callback) => {
    // Allow opening in new tab with Ctrl/Cmd+click or middle-click
    if (e.ctrlKey || e.metaKey || e.button === 1) {
      return; // Let the browser handle it
    }
    // Prevent default navigation and use custom handler
    e.preventDefault();
    callback();
  };

  const displaySubMenuOptions = (nestedSubmenuItem, isActiveNestedSubmenuItem) => {
    return (
      <li
        key={nestedSubmenuItem.id}
        className={isActiveNestedSubmenuItem ? 'active' : ''}
      >
        <a
          href={nestedSubmenuItem.link || '#'}
          className="sub-menu-item-options"
          onClick={(e) => handleLinkClick(
            e,
            () => toggleSubmenuOptions(nestedSubmenuItem.id, nestedSubmenuItem.link),
          )}
          onAuxClick={(e) => e.button === 1 && e.preventDefault()}
        >

          <span className="sub-options-class">{nestedSubmenuItem.text}</span>
        </a>
      </li>
    );
  };
  return (
    <ul className="menu-list" style={{ paddingTop: '20px' }}>
      {menuItems?.map((item) => {
        const isActiveMenuItem = activeMenuItem === item.id;
        const hasSubmenu = item.submenuItems.length > 0;
        // Dropdown visibility is driven purely by "did the user click to expand this",
        // not by whether it happens to be the active/current-route module.
        const isSubmenuOpen = expandedMenuItem === item.id;
        const menuItemTypeClass = hasSubmenu ? 'has-submenu' : 'no-submenu';

        return (
          <li
            key={item.id}
            className={`${isActiveMenuItem ? 'active' : ''} ${menuItemTypeClass}`}
          >
            <a
              href={item.link || '#'}
              className={getMenuItemClass(activeMenuItem, item)}
              onClick={(e) => handleLinkClick(
                e,
                () => toggleMasterSubmenu(item.id, item?.link),
              )}
              onAuxClick={(e) => e.button === 1 && e.preventDefault()}
            >
              <img
                src={isActiveMenuItem ? item.selectedIcon : item.icon}
                alt={`${item.text} Icon`}
                className={`menu-icon ${isActiveMenuItem ? 'active' : ''}`}
              />
              {isOpen && <span className="custom-class">{item.text}</span>}
              {isOpen && hasSubmenu && (
                <img
                  className={`down-arrow${isSubmenuOpen ? ' rotated' : ''}`}
                  src={downArrowIcon}
                  alt="Down Arrow"
                />
              )}
            </a>
            {hasSubmenu && (
              <ul className={`submenu ${isSubmenuOpen ? 'open submenu-background' : ''}`}>
                {item.submenuItems.map((submenuItem) => {
                  const isActiveSubmenuItem = activeSubmenuItem === submenuItem.id;
                  const nestedSubmenuItems = getNestedSubmenuItems(submenuItem);
                  const hasNestedSubmenuItems = nestedSubmenuItems.length > 0;
                  const useRevenueStyles = Boolean(submenuItem.useRevenueStyles);
                  const isSubmenuOptionsOpen = expandedSubmenuItem === submenuItem.id;
                  const submenuItemTypeClass = hasNestedSubmenuItems ? 'has-submenu' : 'no-submenu';
                  const submenuItemStateClass = (
                    isActiveSubmenuItem && hasNestedSubmenuItems
                      ? 'active-submenu-options'
                      : ''
                  );
                  const submenuItemActiveClass = (
                    isActiveSubmenuItem && !hasNestedSubmenuItems
                      ? 'active'
                      : ''
                  );

                  return (
                    <li
                      key={submenuItem.id}
                      className={[
                        submenuItemActiveClass,
                        submenuItemTypeClass,
                        submenuItemStateClass,
                      ].join(' ')}
                    >
                      <a
                        href={submenuItem.link || '#'}
                        className="sub-menu-item"
                        onClick={(e) => handleLinkClick(
                          e,
                          () => toggleSubmenu(
                            submenuItem.id,
                            submenuItem.link,
                            hasNestedSubmenuItems,
                          ),
                        )}
                        onAuxClick={(e) => e.button === 1 && e.preventDefault()}
                      >

                        {isOpen && (
                          <span
                            className={
                              useRevenueStyles
                                ? 'sub-options-revenue'
                                : 'sub-class'
                            }
                          >
                            {submenuItem.text}
                          </span>
                        )}
                        {isOpen && hasNestedSubmenuItems && (
                          <img
                            className={`submenu-option-down-arrow${isSubmenuOptionsOpen ? ' rotated' : ''}`}
                            src={downArrowIcon}
                            alt="Down Arrow"
                          />
                        )}
                      </a>
                      {hasNestedSubmenuItems && (
                        <ul className={`submenu-options ${isSubmenuOptionsOpen ? 'open submenu-background' : ''}`}>
                          {nestedSubmenuItems.map((nestedSubmenuItem) => {
                            const isActiveNestedSubmenuItem = activeSubmenuOption === nestedSubmenuItem.id;

                            return displaySubMenuOptions(nestedSubmenuItem, isActiveNestedSubmenuItem);
                          })}
                        </ul>
                      )}
                    </li>
                  );
                })}
              </ul>
            )}
          </li>
        );
      })}
    </ul>
  );
};

MenuList.propTypes = {
  menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeMenuItem: PropTypes.number,
  activeSubmenuItem: PropTypes.number,
  activeSubmenuOption: PropTypes.number,
  expandedMenuItem: PropTypes.number,
  expandedSubmenuItem: PropTypes.number,
  isOpen: PropTypes.bool.isRequired,
  getMenuItemClass: PropTypes.func.isRequired,
  toggleMasterSubmenu: PropTypes.func.isRequired,
  toggleSubmenu: PropTypes.func.isRequired,
  toggleSubmenuOptions: PropTypes.func.isRequired,
};

export default MenuList;
